import axios from './axios'
import qs from "qs";

function service(endpoint) {

    function fetchCounted(data) {
        return axios.get(`${endpoint}/count`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function fetchProjectList (data) {
        return axios.get(`${endpoint}/list`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        fetchCounted,
        fetchProjectList
    }
}

export default service
